import { translations as coreTranslations } from '@festina-life/core'

import { dk } from './dk'
import { en } from './en'
import { autoGeneratedDk } from './moneyIn/voucher/generated.dk'
import { autoGeneratedEn } from './moneyIn/voucher/generated.en'
import { autoGeneratedNl } from './moneyIn/voucher/generated.nl'
import { nl } from './nl'

export const translations = {
  'en-GB': {
    ...coreTranslations['en-GB'],
    ...en,
    ...autoGeneratedEn,
  },
  'nl-NL': {
    ...coreTranslations['nl-NL'],
    ...nl,
    ...autoGeneratedNl,
  },
  'da-DK': {
    ...coreTranslations['da-DK'],
    ...dk,
    ...autoGeneratedDk,
  },
} as const
